import React from 'react';
import { MdClose } from 'react-icons/md';

/** Shared modal — fixed header/footer, scrollable body. */
const Modal = ({ title, onClose, children, maxWidth = '700px', footer = null }) => (
    <div
        onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
        style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000, padding: 16 }}
    >
        <style>{`.app-modal-body::-webkit-scrollbar { width: 6px; } .app-modal-body::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }`}</style>
        <div
            onClick={(e) => e.stopPropagation()}
            style={{ background: 'white', borderRadius: '16px', maxWidth, width: '90%', maxHeight: '85vh', display: 'flex', flexDirection: 'column', overflow: 'hidden', boxShadow: '0 20px 60px rgba(0,0,0,0.18)' }}
        >
            <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', padding: '24px 24px 0', gap: '12px', flexShrink: 0 }}>
                {title ? (
                    <div style={{ margin: 0, fontSize: '22px', color: '#1a1a1a', flex: 1, fontWeight: 600, lineHeight: 1.3 }}>{title}</div>
                ) : <div style={{ flex: 1 }} />}
                <button
                    type="button"
                    onClick={onClose}
                    aria-label="Close"
                    style={{ background: '#f3f4f6', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#6b7280', padding: '6px', display: 'flex', flexShrink: 0 }}
                >
                    <MdClose size={22} />
                </button>
            </div>
            <div className="app-modal-body" style={{ padding: '20px 24px', overflowY: 'auto', flex: 1 }}>
                {children}
            </div>
            {footer ? (
                <div style={{ padding: '16px 24px 24px', borderTop: '1px solid #f3f4f6', display: 'flex', justifyContent: 'flex-end', gap: 12, flexShrink: 0 }}>
                    {footer}
                </div>
            ) : null}
        </div>
    </div>
);

export default Modal;
